/**
 * Picks a venture's dot canvas by its key, so every page that shows a venture
 * draws the same visual for it.
 */
import React from "react";
import HeroDotSphere from "./HeroDotSphere";
import HexapodDots from "./HexapodDots";

const VISUALS = {
	"2am": HexapodDots,
	azertylabs: HeroDotSphere,
};

/** True when the venture has a dot canvas. */
export const hasVentureVisual = (ventureKey) => ventureKey in VISUALS;

/**
 * The venture's dot canvas, or null for a venture without one. The canvas
 * fills its positioned parent; the caller owns the frame and its size.
 * @param {{ ventureKey: string, className?: string }} props
 */
const VentureVisual = ({ ventureKey, className = "" }) => {
	const Visual = VISUALS[ventureKey];
	return Visual ? <Visual className={className} /> : null;
};

export default VentureVisual;
